var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as R from "ramda";
import intervalToDuration from "./node_modules/date-fns/esm/intervalToDuration/index.mjs";
import addSeconds from "./node_modules/date-fns/esm/addSeconds/index.mjs";
import addHours from "./node_modules/date-fns/esm/addHours/index.mjs";
import subHours from "./node_modules/date-fns/esm/subHours/index.mjs";
import { getFrequencyArtefact } from "./getFrequencyArtefact.mjs";
import { getTimePeriodDimension } from "./getTimePeriodDimension.mjs";
import { FREQUENCY_INTERVALS } from "./constants/frequency.mjs";
const getDataFrequency = ({ attributes, dimensions }) => {
  const frequencyArtefact = getFrequencyArtefact({ attributes, dimensions });
  if (!R.isNil(frequencyArtefact)) {
    return R.pipe(
      R.propOr([], "values"),
      R.head,
      R.prop("id")
    )(frequencyArtefact);
  }
  const timePeriod = getTimePeriodDimension({ dimensions });
  if (R.isNil(timePeriod)) {
    return void 0;
  }
  return R.pipe(
    R.path(["values", 0]),
    ({ start, end }) => {
      const baseEnd = addSeconds(new Date(end), 1);
      const endMinusOneHour = subHours(baseEnd, 1);
      const endPlusOneHour = addHours(baseEnd, 1);
      return R.reduce(
        (acc, endDate) => {
          const interval = intervalToDuration({
            start: new Date(start),
            end: endDate
          });
          const matchIntervals = R.pickBy(
            R.whereEq(interval),
            FREQUENCY_INTERVALS
          );
          return __spreadValues(__spreadValues({}, acc), matchIntervals);
        },
        {},
        [baseEnd, endMinusOneHour, endPlusOneHour]
      );
    },
    R.keys,
    R.head
  )(timePeriod);
};
export {
  getDataFrequency
};
